import React from 'react';
import { Modal, IconsSolid } from '@jkhy/vsg-design-system';

type ConfirmationModalProps = {
  isOpen: boolean,
  onClose: React.Dispatch<React.SetStateAction<null>>
  onSubmit: () => void,
  text: string,
  title: string
}

const ConfirmationModal = ({
  isOpen,
  onClose,
  onSubmit,
  text,
  title,
}: ConfirmationModalProps) => {
  return (
    <Modal
      dataUI="confirmation-modal"
      isVisible={isOpen}
      onClose={onClose}
      title={title}
      onSubmit={onSubmit}
      isClosable
      closeBtnName="No"
      closeBtnIcon={IconsSolid.faTimes}
      actionBtnName="Yes"
      actionBtnIcon={IconsSolid.faCheck}
      size="S"
    >
      <p>{text}</p>
    </Modal>
  );
};

export default ConfirmationModal;
